import { useEffect, useState, useCallback } from "react";
import { List, AlphaCard, Avatar, Badge, Box, Button, Divider, HorizontalGrid, HorizontalStack, Icon, LegacyStack, Link, Modal, Page, Select, Tabs, Text, VerticalStack, TextField, Spinner, ButtonGroup, AlphaTabs, Form, EmptyState, ProgressBar, Image, Pagination } from "@shopify/polaris";
import { updateServerContent, getContent } from "../firebase";
import { ShipmentMajor, PinMajor, AddNoteMajor, CalendarTickMajor, InfoMinor, ArrowLeftMinor, StarOutlineMinor, StarFilledMinor, ArrowRightMinor, StatusActiveMajor, DeleteMajor, ExitMajor, ChecklistMajor, ClockMajor, ComposeMajor, RefundMajor, ThumbsDownMajor, ThumbsUpMajor, CircleTickMajor, CircleAlertMajor, CashDollarMajor, CircleInformationMajor, BillingStatementDollarMajor, LockMajor, CustomerPlusMajor, PlayMajor, EmailMajor, ContentMinor, PagePlusMajor, ImageMajor, IllustrationMajor, OrdersMajor, EditMinor, FinancesMajor, FavoriteMajor, PlayCircleMajor, GlobeMajor, UploadMajor, OutgoingMajor, BehaviorMajor, TeamMajor, ProfileMajor } from "@shopify/polaris-icons";

import { getEmbedByVimeoID } from '../vimeo'
import FileUpload from './file-uploader'

export default function ContentUploadPanel({ content, startingIndex = 0, setLocalNewContent, clickedDeal, profile, refetchContent, refetchDeal }) {

  console.log('content', content)
  const [uploader, setUploader] = useState(null)
  const [uploadOption, setUploadOption] = useState({})
  const [vimeoEmbedsMap, setVimeoEmbedsMap] = useState({})
  const [contentLinks, setContentLinks] = useState({})
  const [uploadingLinkLoading, setUploadingLinkLoading] = useState(false)
  const [revisionIndices, setRevisionIndices] = useState([])

  const [deleteContentLoading, setDeleteContentLoading] = useState(false)

  const [retryTimeout, setRetryTimeout] = useState(null)

  const periods = content?.map((c) => c.period?.periodString).filter((p, i, arr) => arr.indexOf(p) === i)
  const [selectedPeriod, setSelectedPeriod] = useState(periods?.length - 1 || 0)

  useEffect(() => {
    if (content?.length) {
      setSelectedPeriod(periods?.length - 1)
      getAllVimeoEmbeds(content)
      setRevisionIndices(content.map(_ => 0))
    }
  }, [content])

  async function getAllVimeoEmbeds(content) {
    const promises = [];
    content.forEach((c) => {
      if (c.mostRecentUpload) {
        promises.push(getSingleVimeoEmbed(c.id, c.mostRecentUpload));
      } else if (c.directLink) {
        promises.push(
          Promise.resolve({
            embed: <Link url={c.directLink} target="_blank">{c.directLink}</Link>,
            contentID: c.id
          })
        )
      }
    })
    const embeds = await Promise.all(promises);
    if (embeds.some(e => e.retry)) {
      if (!retryTimeout) {
        const timeout = setTimeout(() => {
          getAllVimeoEmbeds(content)
          setRetryTimeout(null)
        }, 15000)
        setRetryTimeout(timeout)
      }
    }
    const embedsMap = {}
    embeds.forEach(embed => {
      embedsMap[embed.contentID] = embed.embed
    })
    setVimeoEmbedsMap(embedsMap)
  }

  async function getSingleVimeoEmbed(contentID, vimeoID) {
    let res;
    try {
      res = await getEmbedByVimeoID(vimeoID)
    } catch (e) {
      console.error('error getting embed', e)
      return {
        embed: <><Text variant="headingLg">404</Text><Text variant="headingSm">Upload Not Found</Text></>,
        contentID
      }
    }
    if (!res.uploadComplete) {
      return {
        retry: true,
        embed: <HorizontalStack gap="2"><Spinner /><VerticalStack gap="2"><Text variant="headingMd">Video Processing...</Text><Text>You can leave this page. It will be ready to view soon</Text></VerticalStack></HorizontalStack>,
        contentID
      }
    } else if (!res.transcodeComplete) {
      //  recursive retry
      //  prevent multiple timeouts
      // 
      return {
        retry: true,
        embed: <HorizontalStack gap="2"><Spinner /><VerticalStack gap="2"><Text variant="headingMd">Video Processing...</Text><Text>You can leave this page. It will be ready to view soon</Text></VerticalStack></HorizontalStack>,
        contentID
      }
    }
    return {
      embed: <div dangerouslySetInnerHTML={{ __html: res.html }} />,
      contentID
    }
  }

  function AddContentByType({ c }) {
    return (
      <VerticalStack gap="3">
        <HorizontalGrid columns="3" gap="1">
          <Button onClick={() => setUploadOption({ ...uploadOption, [c.id]: 'imageFile' })}>
            <Box paddingBlockStart="3" paddingBlockEnd="3">
              <VerticalStack inlineAlign="center" gap="3">
                <Icon source={ImageMajor} color="success" />
                <Text variant="bodyMd">Add Images</Text>
              </VerticalStack>
            </Box>
          </Button>
          <Button onClick={() => setUploadOption({ ...uploadOption, [c.id]: 'videoFile' })}>
            <Box paddingBlockStart="3" paddingBlockEnd="3">
              <VerticalStack inlineAlign="center" gap="3">
                <Icon source={UploadMajor} color="success" />
                <Text variant="bodyMd">Add Video</Text>
              </VerticalStack>
            </Box>
          </Button>
          <Button onClick={() => setUploadOption({ ...uploadOption, [c.id]: 'link' })}>
            <Box paddingBlockStart="3" paddingBlockEnd="3">
              <VerticalStack inlineAlign="center" gap="3">
                <Icon color="success" source={OutgoingMajor} />
                <Text variant="bodyMd">Add Link</Text>
              </VerticalStack>
            </Box>
          </Button>
        </HorizontalGrid>
      </VerticalStack>
    )
  }

  console.log('content', content)

  return (
    <VerticalStack gap="1">
      <HorizontalStack align="space-between">
        {
          clickedDeal?.content?.baseType === 'recurring' || (clickedDeal?.content?.baseType === 'fixed' && periods?.length > 1) ? (
            <Pagination
              label={periods?.[selectedPeriod]}
              hasPrevious={selectedPeriod > 0}
              hasNext={selectedPeriod < periods?.length - 1}
              onPrevious={() => setSelectedPeriod(selectedPeriod - 1)}
              onNext={() => setSelectedPeriod(selectedPeriod + 1)}
            />
          ) : null
        }
      </HorizontalStack>
      {content?.filter(c => {
        if (periods?.length > 1) {
          console.log('periods', periods)
          return periods[selectedPeriod] === c?.period?.periodString
        } else {
          return true
        }
      }).map((c, index) => {
        console.log('c is', c)
        const showingRevisionIndex = revisionIndices[index]
        return (c?.mostRecentUpload || c?.directLink || c?.currentImages?.length) ? (
          <AlphaCard key={index} background="bg-subdued">
            <VerticalStack gap="2">
              <HorizontalStack gap="2">
                <Box padding="">
                  {
                    c.status === 'needsReview' ? (
                      <Icon color="base" source={ClockMajor} />
                    ) : c.status === 'approved' ? (
                      <Icon color="success" source={StatusActiveMajor} />
                    ) : c.status === 'removed' ? (
                      <Icon color="warning" source={DeleteMajor} />
                    ) : c.status === 'deployed' ? (
                      <Icon color="success" source={UploadMajor} />
                    ) : (
                      <Icon color="warning" source={ComposeMajor} />
                    )
                  }
                </Box>
                {
                  c.status === 'needsReview' ? (
                    <Badge>Waiting for Review</Badge>
                  ) : c.status === 'approved' ? (
                    <Badge status="success">Approved</Badge>
                  ) : c.status === 'removed' ? (
                    <Badge status="warning">Removed</Badge>
                  ) : c.status === 'deployed' ? (
                    <Badge status="success">Deployed</Badge>
                  ) : (
                    <Badge status="warning">Changes Requested</Badge>
                  )
                }
              </HorizontalStack>
              {
                c?.currentImages?.length ? (
                  <HorizontalGrid columns={{ xs: "1", md: "2" }}>
                    {
                      c?.currentImages?.map((img, i) => {
                        return (
                          <VerticalStack key={i}>
                            <Image width="100%" source={img.imageURL} />
                          </VerticalStack>
                        )
                      })
                    }
                  </HorizontalGrid>
                ) : (
                  <Box>
                    {vimeoEmbedsMap[c.id]}
                  </Box>
                )
              }
              {
                uploader === index && c.status !== 'approved' ? (
                  uploadOption[c.id] === 'videoFile' ? (
                    <VerticalStack gap="3">
                      <HorizontalStack gap="2" blockAlign="center">
                        <Button onClick={() => setUploadOption({ ...uploadOption, [c.id]: null })} icon={ArrowLeftMinor}></Button>
                        <Text variant="headingMd">Upload Video File</Text>
                      </HorizontalStack>
                      <FileUpload type="videoFile" contentID={c.id} dealID={clickedDeal?.id} uploadCallback={async (vimeoID) => {
                        await updateServerContent(clickedDeal, c.id, { mostRecentUpload: vimeoID })
                        setUploadOption({ ...uploadOption, [c.id]: null })
                        setUploader(null)
                        refetchContent()
                      }} />
                    </VerticalStack>
                  ) : uploadOption[c.id] === 'link' ? (
                    <VerticalStack gap="5">
                      <HorizontalStack gap="2" blockAlign="center">
                        <Button onClick={() => {
                          setUploadOption({ ...uploadOption, [c.id]: null })
                          setDirectLinks({})
                        }} icon={ArrowLeftMinor}></Button>
                        <Text variant="headingMd">Add Link</Text>
                      </HorizontalStack>
                      <TextField
                        label="Link to Google Drive, YouTube, or similar"
                        value={contentLinks[index]}
                        onChange={v => setContentLinks({ ...contentLinks, [index]: v })}
                      />
                      <Button primary loading={uploadingLinkLoading} onClick={async () => {
                        setUploadingLinkLoading(true)
                        try {
                          await updateServerContent(clickedDeal, c.id, { directLink: contentLinks[index] })
                          setUploadOption({ ...uploadOption, [c.id]: null })
                        } catch (e) {
                          alert('Error', e.message)
                        } finally {
                          setUploadingLinkLoading(false)
                        }
                      }}>Add Link</Button>
                    </VerticalStack>
                  ) : uploadOption[c.id] === 'imageFile' ? (
                    <VerticalStack gap="5">
                      <HorizontalStack gap="2" blockAlign="center">
                        <Button onClick={() => setUploadOption({ ...uploadOption, [c.id]: null })} icon={ArrowLeftMinor}></Button>
                        <Text variant="headingMd">Upload Images</Text>
                      </HorizontalStack>
                      <FileUpload type="imageFile" contentID={c.id} uploadCallback={async (imageObjects) => {
                        await updateServerContent(clickedDeal, c.id, { currentImages: imageObjects })
                        setUploadOption({ ...uploadOption, [c.id]: null })
                        setUploader(null)
                        refetchContent()
                      }} />
                    </VerticalStack>
                  ) : (
                    <VerticalStack gap="3">
                      {
                        c.status !== 'pending' ? (
                          <HorizontalStack gap="3" blockAlign="center">
                            <Button icon={ArrowLeftMinor} onClick={() => setUploader(null)}>Back</Button>
                          </HorizontalStack>
                        ) : null
                      }
                      <AddContentByType c={c} />
                    </VerticalStack>
                  )
                ) : uploader === index && (c.status === 'deployed' || c.status === 'approved') ? (
                  <VerticalStack key={c.id} gap="3">
                    <HorizontalStack gap="3" blockAlign="center">
                      <Button icon={ArrowLeftMinor} onClick={() => setUploader(null)} />
                      <Text variant="headingMd" color="success">Add Link to Posted Content</Text>
                    </HorizontalStack>
                  </VerticalStack>
                ) : c.status === 'approved' ? (
                  <HorizontalStack align="end">
                    <Button>Hide</Button>
                  </HorizontalStack>
                ) : null
              }
              {
                c.changesRequested && c.status !== 'approved' && c.status !== 'deployed' ? (
                  <Box width="100%">
                    <AlphaCard>
                      <HorizontalStack gap="2">
                        <Box>
                          <Avatar source={profile?.storeData?.squareLogo} initials={profile?.storeData?.name?.[0]} size="medium" />
                        </Box>
                        <VerticalStack gap="1">
                          <Text color={c.changesOld || showingRevisionIndex !== 0 ? 'subdued' : 'success'} variant="headingSm">{c.changesOld || showingRevisionIndex !== 0 ? "Change Request #" + ((c?.prevChanges?.length || 0) + showingRevisionIndex + 1) : "Current Change Request"}</Text>
                          {
                            showingRevisionIndex === 0 ? (
                              c.changesRequested?.split('\n').map(changeLine => {
                                return (
                                  <Text color={c.changesOld ? 'subdued' : ''}>{changeLine}</Text>
                                )
                              })
                            ) : (
                              c.prevChanges[(c.prevChanges?.length || 0) + showingRevisionIndex]?.split('\n').map(changeLine => {
                                return (
                                  <Text color={c.changesOld ? 'subdued' : ''}>{changeLine}</Text>
                                )
                              })
                            )
                          }
                        </VerticalStack>
                      </HorizontalStack>
                    </AlphaCard>
                  </Box>
                ) : null
              }
              {
                uploader !== c.id ? (
                  <HorizontalStack align="space-between">
                    <ButtonGroup>
                      {c.prevChanges?.length && c.status !== 'deployed' && c.status !== 'approved' ? (
                        <>
                          <Button disabled={Math.abs(showingRevisionIndex) === c.prevChanges?.length} icon={ArrowLeftMinor} onClick={() => {
                            const newRevisionIndices = [...revisionIndices]
                            newRevisionIndices[index] = showingRevisionIndex - 1
                            setRevisionIndices(newRevisionIndices)
                          }} />
                          <Button disabled={showingRevisionIndex === 0} icon={ArrowRightMinor} onClick={() => {
                            const newRevisionIndices = [...revisionIndices]
                            newRevisionIndices[index] = showingRevisionIndex + 1
                            setRevisionIndices(newRevisionIndices)
                          }} />
                        </>
                      ) : (
                        null
                      )
                      }
                    </ButtonGroup>
                    {
                      (c.status === 'needsReview' || c.status === 'changesRequested') && uploader !== index ? (
                        <ButtonGroup>
                          <Button disabled={uploader !== null && uploader !== index} onClick={() => setUploader(index)}>
                            Add New Version
                          </Button>
                          {/*
<Button loading={deleteContentLoading} onClick={() => deleteContent(c.id)}>
Remove
</Button>
*/}
                        </ButtonGroup>
                      ) : (
                        <Box />
                      )
                    }
                  </HorizontalStack>
                ) : null
              }
            </VerticalStack>
          </AlphaCard>
        ) : (
          <AlphaCard key={index} background="bg-success-subdued-hover" padding="5" >
            <VerticalStack gap="5" key={index}>
              <HorizontalStack align="space-between">
                <HorizontalStack gap="2" key={'content-' + index}>
                  <Box>
                    <Icon color="interactive" source={UploadMajor} />
                  </Box>
                  <HorizontalStack>
                    <Badge status={c.status === 'deployed' ? 'success' : "info"}>
                      {
                        c?.status === 'deployed' ? 'Content Deployed'
                          : clickedDeal?.content?.reviewContent ? 'Upload Content Now'
                            : 'Add Content Link'}
                    </Badge>
                  </HorizontalStack>
                </HorizontalStack>
                <Text color="subdued">
                  For Review
                </Text>
              </HorizontalStack>
              <VerticalStack gap="5" key={index}>
                {
                  clickedDeal?.content?.reviewContent ? (
                    uploadOption[c.id] === 'videoFile' ? (
                      <VerticalStack gap="5">
                        <HorizontalStack gap="2" blockAlign="center">
                          <Button onClick={() => setUploadOption({ ...uploadOption, [c.id]: null })} icon={ArrowLeftMinor}></Button>
                          <Text variant="headingMd">Upload Video File</Text>
                        </HorizontalStack>
                        <FileUpload type="videoFile" contentID={c.id} uploadCallback={async (vimeoID) => {
                          await updateServerContent(clickedDeal, c.id, { mostRecentUpload: vimeoID })
                          setUploadOption({ ...uploadOption, [c.id]: null })
                          setUploader(null)
                          refetchContent()
                        }} />
                      </VerticalStack>
                    ) : uploadOption[c.id] === 'link' ? (
                      <VerticalStack gap="5">
                        <HorizontalStack gap="2" blockAlign="center">
                          <Button onClick={() => {
                            setUploadOption({ ...uploadOption, [c.id]: null })
                            setDirectLinks({})
                          }} icon={ArrowLeftMinor}></Button>
                          <Text variant="headingMd">Add Link</Text>
                        </HorizontalStack>
                        <TextField
                          label="Link to Google Drive, YouTube, or similar"
                          value={contentLinks[index]}
                          onChange={v => setContentLinks({ ...contentLinks, [index]: v })}
                        />
                        <Button primary loading={uploadingLinkLoading} onClick={async () => {
                          setUploadingLinkLoading(true)
                          try {
                            await updateServerContent(clickedDeal, c.id, { directLink: contentLinks[index] })
                            setUploadOption({ ...uploadOption, [c.id]: null })
                          } catch (e) {
                            alert('Error', e.message)
                          } finally {
                            setUploadingLinkLoading(false)
                          }
                        }}>Add Link</Button>
                      </VerticalStack>
                    ) : uploadOption[c.id] === 'imageFile' ? (
                      <VerticalStack gap="5">
                        <HorizontalStack gap="2" blockAlign="center">
                          <Button onClick={() => setUploadOption({ ...uploadOption, [c.id]: null })} icon={ArrowLeftMinor}></Button>
                          <Text variant="headingMd">Upload Image Files</Text>
                        </HorizontalStack>
                        <FileUpload type="imageFile" contentID={c.id} uploadCallback={async (imageObjects) => {
                          await updateServerContent(clickedDeal, c.id, { currentImages: imageObjects })
                          setUploadOption({ ...uploadOption, [c.id]: null })
                          setUploader(null)
                          refetchContent()
                        }} />
                      </VerticalStack>
                    ) : (
                      <VerticalStack gap="3">
                        {
                          c.status !== 'new' ? (
                            <HorizontalStack gap="3" blockAlign="center">
                              <Button icon={ArrowLeftMinor} onClick={() => setUploader(null)}>Back</Button>
                            </HorizontalStack>
                          ) : null
                        }
                        <HorizontalGrid columns="3" gap="1">
                          <Button onClick={() => setUploadOption({ ...uploadOption, [c.id]: 'imageFile' })}>
                            <Box paddingBlockStart="3" paddingBlockEnd="3">
                              <VerticalStack inlineAlign="center" gap="3">
                                <Icon source={ImageMajor} color="success" />
                                <Text variant="bodyMd">Add Images</Text>
                              </VerticalStack>
                            </Box>
                          </Button>
                          <Button onClick={() => setUploadOption({ ...uploadOption, [c.id]: 'videoFile' })}>
                            <Box paddingBlockStart="3" paddingBlockEnd="3">
                              <VerticalStack inlineAlign="center" gap="3">
                                <Icon source={UploadMajor} color="success" />
                                <Text variant="bodyMd">Add Video</Text>
                              </VerticalStack>
                            </Box>
                          </Button>
                          <Button onClick={() => setUploadOption({ ...uploadOption, [c.id]: 'link' })}>
                            <Box paddingBlockStart="3" paddingBlockEnd="3">
                              <VerticalStack inlineAlign="center" gap="3">
                                <Icon color="success" source={OutgoingMajor} />
                                <Text variant="bodyMd">Add Link</Text>
                              </VerticalStack>
                            </Box>
                          </Button>
                        </HorizontalGrid>
                      </VerticalStack>
                    )
                  ) : (
                    uploader === index ? (
                      <VerticalStack key={c.id} gap="3">
                        <HorizontalStack gap="3" blockAlign="center">
                          <Button icon={ArrowLeftMinor} onClick={() => setUploader(null)} />
                          <Text variant="headingMd" color="success">Add Link to Posted Content</Text>
                        </HorizontalStack>
                        <TextField
                          helpText="Link to Social Media Post (IG, Tiktok, YouTube)"
                          value={contentLinks[index]}
                          onChange={v => setContentLinks({ ...contentLinks, [index]: v })}
                        />
                        <ButtonGroup>
                          <Button primary loading={uploadingLinkLoading} onClick={async () => {
                            setUploadingLinkLoading(true)
                            try {
                              await updateServerContent(clickedDeal, c.id, { deployLink: contentLinks[index] })
                              setUploader(null)
                              refetchContent()
                              refetchDeal()
                              setLocalNewContent(content.filter((_, i) => index !== i))
                            } catch (e) {
                              console.error(e.message)
                            } finally {
                              setUploadingLinkLoading(false)
                            }
                          }}>Add Link</Button>
                        </ButtonGroup>
                      </VerticalStack>
                    ) : (
                      <VerticalStack gap="3" align="space-between">
                        {vimeoEmbedsMap[c.id] || null}
                        <Link external url={c.deployLink}>{c.deployLink}</Link>
                        <ButtonGroup>
                          <Button onClick={() => {
                            setUploader(index)
                            setContentLinks({ ...contentLinks, [index]: c.deployLink })
                          }}>{c.deployLink ? 'Edit Published Link' : 'Add Published Link'}</Button>
                          {
                            startingIndex ? (
                              <Button onClick={() => {
                                setLocalNewContent(content.filter((_, i) => index !== i))
                              }}>Remove</Button>
                            ) : null
                          }
                        </ButtonGroup>
                      </VerticalStack>
                    )
                  )
                }
              </VerticalStack>
            </VerticalStack>
          </AlphaCard>
        )
      })}
    </VerticalStack >
  )
}
